// extracted by mini-css-extract-plugin
module.exports = {"badge":"profile-image-skins-xlargeOnWide-badge-e098bd3a"};